import React from 'react';
import { Link } from 'react-router-dom';
import routes from './routes';
import { connect } from 'react-redux';
import packageJson from '../package.json';
import styled, { createGlobalStyle } from 'styled-components';
import { Layout, Menu, Button, Drawer } from 'antd';
import { LogoutOutlined, MenuOutlined } from '@ant-design/icons';
import { doLogout } from './redux/AuthActions';
import Icon from '@mdi/react';
import {
  mdiAccountMultiple,
  mdiAccountTie,
  mdiBarley,
  mdiFinance,
  mdiHomeSiloOutline,
  mdiSpray,
  mdiTractorVariant,
  mdiWaves,
  mdiAccountSupervisorCircle,
  mdiAccountCircle,
} from '@mdi/js';

const { Header, Content } = Layout;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

const HeaderTitle = styled.div`
  flex: 1;
  margin-left: 10px;
`;

const LayoutStyle = createGlobalStyle`

.ant-layout-header{
  background:#f0f2f5;
  padding: 0;
  height: auto;
  line-height: 0;
}

.ant-layout-content{
  background:#f0f2f5;
  padding: 0;
}

.ant-layout-footer{
  background:#f0f2f5;
  padding: 0;
  height: auto;
}

.ant-table.ant-table-small
  .ant-table-tbody
  .ant-table-wrapper:only-child
  .ant-table {
  margin: 0;
}

`;

const HeaderIcons = styled.div``;
const Navbar = ({ dispatch, cache }) => {
  const [visible, setVisible] = React.useState(false);

  const logout = () => {
    doLogout(dispatch);
  };
  const onClose = () => {
    setVisible(false);
  };

  const menuItems = [
    {
      key: '1',
      icon: <Icon path={mdiFinance} size={1} />,
      label: (
        <Link to="" onClick={() => onClose()}>
          Dashboard
        </Link>
      ),
    },
    {
      key: '8',
      icon: <Icon path={mdiWaves} size={1} />,
      label: (
        <Link to="/campanas" onClick={() => onClose()}>
          Campañas
        </Link>
      ),
    },
    {
      key: '2',
      icon: <Icon path={mdiHomeSiloOutline} size={1} />,
      label: (
        <Link to="/establecimientos" onClick={() => onClose()}>
          Establecimientos
        </Link>
      ),
    },
    {
      key: '9',
      icon: <Icon path={mdiAccountTie} size={1} />,
      label: (
        <Link to="/propietarios" onClick={() => onClose()}>
          Propietarios
        </Link>
      ),
    },
    {
      key: '3',
      icon: <Icon path={mdiBarley} size={1} />,
      label: (
        <Link to="/cultivos" onClick={() => onClose()}>
          Cultivos
        </Link>
      ),
    },
    {
      key: '4',
      icon: <Icon path={mdiSpray} size={1} />,
      label: (
        <Link to="/insumos" onClick={() => onClose()}>
          Insumos
        </Link>
      ),
    },
    {
      key: '5',
      icon: <Icon path={mdiTractorVariant} size={1} />,
      label: (
        <Link to="/labores" onClick={() => onClose()}>
          Labores
        </Link>
      ),
    },
    {
      key: '10',
      icon: <Icon path={mdiAccountSupervisorCircle} size={1} />,
      label: (
        <Link to="/sociedades" onClick={() => onClose()}>
          Sociedades
        </Link>
      ),
    },
    {
      key: '6',
      icon: <Icon path={mdiAccountCircle} size={1} />,
      label: (
        <Link to="/inversores" onClick={() => onClose()}>
          Aportantes
        </Link>
      ),
    },
    {
      key: '7',
      icon: <Icon path={mdiAccountMultiple} size={1} />,
      label: (
        <Link to="/proveedores" onClick={() => onClose()}>
          Proveedores
        </Link>
      ),
    },
  ];

  return (
    <>
      <LayoutStyle />

      <Drawer
        title={null}
        placement="left"
        closable={true}
        onClose={(e) => onClose()}
        open={visible}
        getContainer={false}
        style={{ position: 'fixed', zIndex: 999 }}
        bodyStyle={{ padding: 0 }}
        width={250}
        headerStyle={{ padding: '10px' }}
        extra={
          <div style={{ width: '210px', paddingLeft: '10px' }}>
            <img style={{ width: '100%' }} src={'logo_largo.png'} alt="Logo" />
          </div>
        }
      >
        <div
          style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
        >
          <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
            <Menu mode="inline" items={menuItems} />
          </div>
          <div
            style={{
              padding: '10px',
              borderTop: '1px solid #f0f0f0',
              textAlign: 'center',
            }}
          >
            FE: {packageJson.version} - BE: {cache.list.data.version}
          </div>
        </div>
      </Drawer>

      <div style={{ height: '100vh' }}>
        <Layout style={{ height: '100%' }}>
          <Header
            style={{ position: 'fixed', top: 0, width: '100%', zIndex: 998 }}
          >
            <HeaderContainer className="site-layout-sub-header-background">
              <Button
                type="primary"
                icon={<MenuOutlined />}
                size="small"
                onClick={(e) => setVisible(!visible)}
              />

              <HeaderTitle>Gestión Agro</HeaderTitle>
              <HeaderIcons>
                <LogoutOutlined onClick={() => logout()} />
              </HeaderIcons>
            </HeaderContainer>
          </Header>
          <Content
            style={{
              margin: '15px',
              paddingTop: 64,
            }}
          >
            {routes}
          </Content>
        </Layout>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const { cache } = state;
  return { cache };
};

export default connect(mapStateToProps)(Navbar);
